import type { LogEntry, LogAction } from "../types";
export default function log(
  state: LogEntry<any>[] | null | undefined = null,
  action: LogAction<any>
): LogEntry<any>[] | null {
  switch (action.type) {
    case "ADD_LOG":
      if (state == null) {
        return [action.logentry];
      }

      return [...state, action.logentry];

    case "LOAD_LOG_SUCCEEDED":
      return action.entries.filter((entry) => entry != null);
  }

  return state;
}
